import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { MemberSidebar } from "@/components/dashboard/MemberSidebar";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { SEO } from "@/components/SEO";

export function MemberLayout() {
  return (
    <SidebarProvider>
      <SEO title="Dashboard" noindex={true} />
      <div className="dashboard-area min-h-screen flex w-full">
        <MemberSidebar />
        <SidebarInset>
          <DashboardHeader />
          <main className="flex-1 p-4 lg:p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
